import api from "../api/axiosInstance";

const deliveryReceiptService = {
    // items: [{ shipmentId, itemId }, ...] — item-level, not whole-shipment
    // (a receipt can be a subset of a shipment's items).
    create: (items) => api.post("/delivery-receipts", { items }),
    // A customer's items that are free to go on a new manual receipt
    // (excludes delivered items and items already on another open receipt),
    // grouped by shipment — powers the "select a whole shipment or specific
    // items" picker.
    getEligibleItems: (customerId) => api.get("/delivery-receipts/eligible-items", { params: { customerId } }),
    remove: (id) => api.delete(`/delivery-receipts/${id}`),
    getAll: (params) => api.get("/delivery-receipts", { params }),
    getOne: (id) => api.get(`/delivery-receipts/${id}`),
    getAvailable: () => api.get("/delivery-receipts/available"),
    getMine: () => api.get("/delivery-receipts/mine"),
    claim: (id) => api.post(`/delivery-receipts/${id}/claim`),
    release: (id) => api.post(`/delivery-receipts/${id}/release`),
    presignAsset: (id, type) => api.post(`/delivery-receipts/${id}/presign`, { type }),
    submit: (id, payload) => api.post(`/delivery-receipts/${id}/submit`, payload),
    fail: (id, failureReason) => api.post(`/delivery-receipts/${id}/fail`, { failureReason }),
    getAssetUrl: (id, type) => api.get(`/delivery-receipts/${id}/asset-url`, { params: { type } }),
};

export default deliveryReceiptService;